<script>
import { get, intersection } from "lodash";
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { VodafoneLab } from "../../modules/vodafone_lab_module.js";

export default {
  mixins: [fandomBasicMixin],
  data() {
    return {
      search: false,
      searchText: "",
      scrolled: true,
      mobileMenuOpened: false,
      mobileProfileMenuOpened: false,
    };
  },
  created() {
    if (get(globalState.pageModel, ['main_content_name'], '') === 'home-page') {
      Fandom.deleteCookie('active_target');
    }
  },
  methods: {
    isUserRegistered: Fandom.isUserRegistered,
    isItemActive(item) {
      let cookie = Fandom.readCookie("active_target");
      if (!!cookie) return get(item, ['url', 'content'], '') === cookie.split('=')[1];
      if (item.url && item.url.content && !item.matching_name) {
        item.matching_name = item.url.content;
      }
      const re = new RegExp(`^(${item.matching_name})$`);
      return re.test(globalState.pageModel.main_content_name);
    },
    setActiveTarget(item) {
      if (item.url && item.url.content) {
        Fandom.setCookie("active_target", item.url.content);
      }
    },
    getUrl(url, parameter="icmp") {
      if (!url) return 'javascript:void(0)';
      if (url.includes("?")) {
        return `${url}&${parameter}=MMD`;
      } else {
        return `${url}?${parameter}=MMD`;
      }
    },
    openSearch() {
      this.search = true;
      Vue.nextTick(() => {
        setTimeout(() => {
          $("#searchField").focus();
        }, 1000);
      });
    },
    logOutTracking(item) {
      if (item.url.url.includes('sign_out'))
        VodafoneLab.addDigitalDataEvent("logout", "user", ":Logout");
    },
    doSearch() {
      window.location.href = `${this.resultUrl}?q=${encodeURI(this.searchText)}`;
    },
    toggleDesktopProfileMenu() {
      $(this.$refs["profile-menu"]).collapse("toggle");
    },
    toggleProfileSubMenu(event, elId) {
      $(`#${elId}`).collapse('toggle');
      $(event.target).toggleClass('expanded');
    },
    toggleBodyScrollLock(flag, ref) {
      flag ? disableBodyScroll(this.$refs[ref]) : enableBodyScroll(this.$refs[ref]);
    },
    toggleMobileMenu() {
      if (this.mobileProfileMenuOpened && !this.mobileMenuOpened) {
        this.toggleProfileMobileMenu();
      }
      this.mobileMenuOpened = !this.mobileMenuOpened;
      this.toggleBodyScrollLock(this.mobileMenuOpened, 'mobile-menu');
    },
    toggleProfileMobileMenu() {
      if (!this.mobileProfileMenuOpened && this.mobileMenuOpened) {
        this.toggleMobileMenu();
      }
      this.mobileProfileMenuOpened = !this.mobileProfileMenuOpened;
      this.toggleBodyScrollLock(this.mobileProfileMenuOpened, 'profile-mobile-menu');
    },
    canShowUserItem(item) {
      if (!item.access_contents && !item.user_targets) return true;
      const accessContents = !!item.access_contents ? intersection(get(this, ["pageModel","user","contents"], []), item.access_contents).length > 0 : true;
      const userTarget = !!item.user_targets ? intersection(item.user_targets, get(this, ["pageModel","user","target"], [])).length > 0 : true;
      return userTarget && accessContents;
    },
    isItemHidden(item) {
      return (!Fandom.isUserRegistered() &&  item.hide_to_anonymous_user) || (Fandom.isUserRegistered() && item.hide_to_registered_user);
    }
  },
  computed: {
    contentStyle() {
      return {
        "--navbar-item-width": `${100/this.items.length}%`
      }
    },
    resultUrl() {
      return get(this.content, ['search_result_url','url'], "search");
    },
    items() {
      const globalItems = get(globalState, ["pageModel", "layout", "header", "navbar_items"], []);
      if (!this.userTarget) {
        return globalItems;
      } else {
        const targetPageName = this.userTarget.split('target-')[1];
        const targetNavRecord = globalItems.find((item) => get(item, ["url", "content"], {}).includes(targetPageName));
        return get(targetNavRecord, ['items'], []);
      }
    },
    userTarget() {
      return get(globalState, ["pageModel", "user", "target", 0], false);
    },
    profileMenuContent() {
      if (this.content.profile_menu) {
        return {
          name: 'profile-menu',
          $id: this.content.profile_menu[0].$id,
          navbar_items: this.content.profile_menu
        }
      } else {
        return false;
      }
    },
    logoAlt() {
      return get(this.pageModel, ['seo', 'title'], '');
    },
    logo() {
      return get(globalState, ["pageModel", "layout", "header", "logo"], {});
    },
    isUserPage() {
      return this.mainContent.user_page;
    },
    isDesktop() {
      return get(globalState, ["viewport", "md"], false) || get(globalState, ["viewport", "lg"], false) || get(globalState, ["viewport", "xl"], false);
    }
  },
};
</script>

<template>
  <div id="main-navbar" class="sticky-top" :style="contentStyle">
    <div v-if="content.navbar_top" class="py-1 bg-gray-900 d-none d-lg-block">
      <div class="container">
        <div class="row">
          <div class="col col-lg-9">
            <a
              v-for="(item, index) in content.navbar_top"
              :key="`navbar-top-item-${index}`"
              :target="getTarget(item.url, 'ecmp')"
              :href="getUrl(item.url.url, 'ecmp')"
              class="text-white top-navbar-item px-5"
              >
              {{item.url.title}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="position-relative px-md-3 px-lg-0" :class="{'shadow': scrolled || mobileMenuOpened, 'user-registered-navbar': isUserRegistered()}" navbar-component>
      <div class="container-lg bg-white d-flex justify-content-between justify-content-lg-center px-md-0">
        <div class="d-flex align-items-center">
          <div class="toggler animated-border h-100 d-lg-none mr-3 d-flex align-items-center" @click="toggleMobileMenu" :class="{'active': mobileMenuOpened}">
            <i class="fal fa-bars"></i>
          </div>
          <a class="pr-3 py-2 my-1" href="/?icmp=MMD">
            <img :src="logo.url" class="logo" :alt="logoAlt">
          </a>
        </div>
        <div class="d-none d-lg-flex flex-grow-1 justify-content-start">
          <component
            :is="!!item.url ? 'a' : 'div'"
            class="navbar-item px-4 text-center"
            v-for="(item, index) in items.filter(i => !isItemHidden(i))"
            :key="`item-${index}`"
            :class="{'active': isItemActive(item)}"
            :href="getUrl((item.url || {}).url)"
            :target="getTarget(item.url)"
            @click="setActiveTarget(item)"
          >
            <span :style="{'color': item.color || '#000000'}" class="d-inline-block mb-0 cursor-pointer h-100 d-flex align-items-center">
              {{item.title || item.url.title}}
            </span>
            <div class="w-100 position-relative hover-selector"></div>
            <div class="navbar-subitems position-absolute justify-content-center" v-if="item.items">
              <div class="navbar-subitem py-1 mx-3" v-for="(subitem, subindex) in item.items.filter(i => !isItemHidden(i))" :key="`item-${index}-${subindex}`">
                <a class="d-inline-block py-3 mb-0 my-1" :href="getUrl(subitem.url.url)" :target="getTarget(subitem.url)" @click="setActiveTarget(item)">
                  {{subitem.url.title}}
                </a>
              </div>
            </div>
          </component>
        </div>
        <div class="d-flex align-items-center right-icons-container position-relative">
          <div class="h-100 mr-3 align-items-center cursor-pointer d-none d-md-flex" @click="openSearch()">
            <svg class="right-icon">
              <use xlink:href="#search-icon"></use>
            </svg>
          </div>
          <a
            v-if="!isUserRegistered()"
            class="h-100 d-flex align-items-center link-dark"
            :href="getUrl(applyContextToUrl('/users/sign_in'))"
            :class="{'active': isUserPage}"
          >
            <svg class="right-icon mr-3 mr-md-4">
              <use xlink:href="#profile-icon"></use>
            </svg>
            <a
              :href="content.vbl_premium.url.url"
              v-if="content.vbl_premium && content.vbl_premium.url"
              :target="getTarget(content.vbl_premium.url)"
            >
              <img class="vbl-premium-icon" v-if="content.vbl_premium.icon" :src="content.vbl_premium.icon.url"/>
            </a>
          </a>
          <template v-else-if="!!getContent(userTarget)">
            <div v-if="!isDesktop && !!getContent(userTarget).profile_icon" class="mobile-avatar cursor-pointer text-white rounded-circle bg-primary text-center d-flex justify-content-center align-items-center" @click="toggleProfileMobileMenu">
              <img :src="getContent(userTarget).profile_icon.url" class="image-fluid"/>
            </div>
            <div v-else-if="!!getContent(userTarget)" class="h-100 d-flex align-items-center bg-primary px-3 py-2 cursor-pointer position-relative user-section" :class="{'active': isUserPage}" @click="toggleDesktopProfileMenu" data-toggle="collapse">
              <div class="target-icon bg-white rounded-circle d-flex justify-content-center align-items-center mr-3" v-if="getContent(userTarget).profile_icon">
                <img :src="getContent(userTarget).profile_icon.url" class="image-fluid"/>
              </div>
              <div>
                <div class="text-white font-weight-normal mb-0 target-text">
                  {{pageModel.user.username}}
                </div>
                <div class="text-white small target-text">
                  {{getContent(userTarget).title}}
                </div>
                <div class="text-white target-text last-sign-in-at">Ultimo accesso {{ pageModel.user.last_sign_in_at }}</div>
              </div>
              <template v-if="content.profile_menu">
                <div class="collapse position-absolute user-dropdown w-100" v-show="isDesktop" ref="profile-menu">
                  <div class="user-link-container bg-white">
                    <div
                      class="user-link w-100 text-left"
                      v-for="(item, index) in content.profile_menu"
                      :class="{'border-top': index > 0}"
                      :key="index"
                    >
                      <a
                        v-if="item.items"
                        href="javascript:void(0)"
                        @click.prevent.stop="toggleProfileSubMenu($event, `user-submenu-${index}-collapse`)"
                        class="px-3 py-2 d-block w-100 d-flex justify-content-between align-items-center"
                      >
                        {{item.title}}
                        <i class="fal fa-chevron-down fa-lg"></i>
                      </a>
                      <div class="collapse bg-gray-200" v-if="item.items" :id="`user-submenu-${index}-collapse`">
                        <div class="py-2">
                          <div
                            class="user-link px-3 w-100 text-left"
                            v-for="(subitem, subindex) in item.items"
                            :key="`user-menu-subitem-${subindex}`"
                          >
                            <a
                              class="small"
                              :class="subitem.text_primary ? 'text-primary' : 'link-dark'"
                              :href="getUrl(subitem.url.url)"
                              :target="getTarget(subitem.url)"
                              @click="setActiveTarget(subitem)"
                            >{{subitem.url.title}}</a>
                          </div>
                        </div>
                      </div>
                      <a
                        v-if="item.url && canShowUserItem(item)"
                        @click="logOutTracking(item)"
                        :class="item.text_primary ? 'text-primary' : 'link-dark'"
                        :href="getUrl(item.url.url)"
                        :target="getTarget(item.url)"
                        class="px-3 py-2 d-block"
                      >{{item.url.title}}</a>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
      <!-- search bar -->
      <transition enter-active-class="animated faster slideInRight" leave-active-class="animated faster slideOutRight">
        <div class="search-bar position-absolute d-flex container-lg" v-if="search" :class="{'active': !!searchText}">
          <a class="pr-3 py-2 my-1 d-none d-md-block" href="/">
            <img :src="logo.url" class="logo logo-placeholder" :alt="logoAlt">
          </a>
          <div class="input-group d-flex flex-grow-1 py-lg-2 pr-3 pr-md-4 bg-white">
            <input type="text" id="searchField" class="custom-input input-group-prepend flex-grow-1 px-3 px-md-4 py-2" v-on:keyup.enter="doSearch()" v-model="searchText" :placeholder="ft('globals.search')">
            <div class="input-group-append">
              <button class="btn px-3 py-2 text-white" :class="!!searchText ? 'btn-primary' : 'btn-gray-ccc'" @click="doSearch()"><i class="fal fa-search"></i></button>
            </div>
          </div>
          <div class="h-100 d-flex align-items-center bg-white cursor-pointer" @click="search = false">
            <i class="fal fa-times"></i>
          </div>
        </div>
      </transition>
    </div>
    <!-- mobile sidebars -->
    <transition enter-active-class="animated faster fadeIn" leave-active-class="animated faster fadeOut">
      <div class="layer" v-show="mobileMenuOpened || mobileProfileMenuOpened"></div>
    </transition>
    <transition enter-active-class="animated faster fadeInLeft" leave-active-class="animated faster fadeOutLeft">
      <navbar-mobile ref="mobile-menu" class="w-limiter d-lg-none" :content="content" @close="toggleMobileMenu" :opt-container-content="content" v-show="mobileMenuOpened"></navbar-mobile>
    </transition>
    <transition enter-active-class="animated faster fadeInLeft" leave-active-class="animated faster fadeOutLeft">
      <navbar-mobile v-if="isUserRegistered()" ref="profile-mobile-menu" class="w-limiter d-lg-none" :content="profileMenuContent" @close="toggleProfileMobileMenu" :opt-container-content="content" v-show="mobileProfileMenuOpened"></navbar-mobile>
    </transition>
  </div>
</template>

<style lang="scss" scoped>

.sticky-top {
  z-index: 1081;
}

.top-navbar-item {
  @include font-size(1rem);
}

[navbar-component] {
  // for shadow effect
  transition: all .5s;
  background-color: $white;

  .user-section {
    min-width: 300px;
  }

  .user-dropdown {
    @include font-size(1.125rem);
    z-index: 1;

    @include media-breakpoint-up(md) {
      right: 0;
      top: 100%;
    }
  }

  .user-link-container {
    width: 100%;
    box-shadow: 0 .125rem .5rem 0 rgba($black, .15);
  }

  .user-link > a.expanded > i {
    transform: rotate(180deg);
  }

  .link-dark {
    color: $dark;

    @include hover {
      color: $gray-500;
    }
  }

  .last-sign-in-at {
    font-size: 0.75rem;
    line-height: initial !important;
  }

  .target-text {
    line-height: 1.25rem;
  }

  .mobile-avatar, .target-icon {
    flex: 0 0 auto;

    width: 2.5rem;
    height: 2.5rem;

    img {
      height: 1.5rem;
      @include recolor-icon;
    }
  }

  .mobile-avatar > img {
    filter: invert(0%) sepia(150%) saturate(0%) hue-rotate() brightness(1000%) contrast();
  }

  .animated-border {
    border-top: 3px solid transparent;
    border-bottom: 3px solid transparent;
    transition: border-color 500ms;

    &.active,
    &[aria-expanded="true"] {
      border-bottom: 3px solid $primary;
    }
  }

  .toggler {
    > i {
      @include font-size(1.5rem);
    }
  }

  .logo {
    height: 3rem;
    width: auto;
  }

  .navbar-item {
    // max-width: var(--navbar-item-width);
    // flex-basis: var(--navbar-item-width) !important;
    line-height: 1.1;

    & > .navbar-subitems {
      left: 0;
      right: 0;
      top: 100%;
      height: 0;
      opacity: 0;
      display: flex;
      overflow: hidden;
      transition: height .25s;
      background-color: rgba(255, 255, 255, .9);
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);

      & > .navbar-subitem > a {
        transition: color;
        color: $black;
      }
    }

    &:hover > .navbar-subitems {
      height: 100%;
      opacity: 1;

      & > .navbar-subitem > a:hover {
        color: $gray-900;
      }
    }

    &.active .hover-selector::after,
    &:hover .hover-selector::after {
      border-bottom: 3px solid $primary;
      position: absolute;
      content: '';
      bottom: 0;
      right: 0;
      left: 0;
    }

  }

  .right-icons-container {

    div.active {
      border-bottom: 3px solid $primary;
    }

    .right-icon {
      width: 1.5rem;
      height: 1.5rem;
      stroke: black;
    }

    .right-icon {
      &:hover {
        @include recolor-icon;
      }
    }
  }

  .vbl-premium-icon {
    width: 2.5rem;
    height: 2.5rem;
  }

  .search-bar {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(to left,  rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%);

    .btn {
      transition: all .25s;
    }


    .custom-input {
      background-color: white;
      border: 1px solid $gray-500;
      transition: border .25s;

      &:focus {
        outline: none !important;
        box-shadow: none !important;
      }
    }

    .logo-placeholder {
      opacity: 0;
    }

    i { @include font-size(1.5rem); }

    &.active {
      .custom-input {
        border: 2px solid $ocean;
      }
    }
  }

  @include media-breakpoint-down(md) {
    .logo {
      height: 2rem;
    }
  }

  @include media-breakpoint-only(xs) {
    .search-bar .custom-input {
      width: calc(100% - 56px);
    }
  }
}

.layer {
  background-color: rgba($gray-900, .5);
  top: $header-height-sm;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: -1;
}
</style>
